import AppSidebar from "./AppSidebar";
import AgentPanel from "./AgentPanel";

interface AppLayoutProps {
  children: React.ReactNode;
  /** Pass false to hide the right agent panel on certain pages */
  showAgent?: boolean;
}

/**
 * Three-column SaaS shell:
 *   [AppSidebar 250px] | [children flex-1] | [AgentPanel 350px]
 * The entire layout fills the viewport height without page-level scroll.
 * Each column manages its own internal scroll.
 */
export default function AppLayout({ children, showAgent = true }: AppLayoutProps) {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-gray-50">
      <AppSidebar />

      {/* Center workspace — fills remaining space */}
      <main className="flex-1 min-w-0 overflow-y-auto">
        {children}
      </main>

      {showAgent && <AgentPanel />}
    </div>
  );
}
